export default __webpack_public_path__ + "static/media/monitor.55f76939.svg";